export const ActionType = {
    GET_SMSC_LIST : 'GET_SMSC_LIST'
}